// src/shared/utils/dateUtils.ts
import { differenceInDays, differenceInMonths, isValid } from "date-fns";

function parseSafeDate(raw?: string | null): Date | null {
	if (!raw || typeof raw !== "string" || raw.includes("NaN")) return null;

	try {
		const dateStr = raw.substring(0, 10) + " 03:00:00";
		const parsed = new Date(dateStr);
		return isValid(parsed) ? parsed : null;
	} catch {
		return null;
	}
}

export function getDurationLabelFromRawDates(startRaw?: string | null, endRaw?: string | null): string {
	const start = parseSafeDate(startRaw);
	const end = parseSafeDate(endRaw);

	if (!start || !end) return "";

	const diffDays = differenceInDays(end, start);

	if (diffDays <= 29) {
		return `(${diffDays} dia${diffDays !== 1 ? "s" : ""})`;
	} else {
		const diffMonths = differenceInMonths(end, start);
		return `(${diffMonths} mes${diffMonths !== 1 ? "es" : ""})`;
	}
}
